import {useState} from "react";
import axios from "axios";
import toast from "react-hot-toast";
import {XMarkIcon} from "@heroicons/react/24/outline";

const DispatchInfoForm = ({
  orderId,
  itemId,
  onClose,
  setSelectedDeliveries,
}: {
  orderId: string;
  itemId: string;
  onClose?: () => void;
  setSelectedDeliveries: React.Dispatch<React.SetStateAction<any[]>>;
}) => {
  const [dispatchProviderName, setDispatchProviderName] = useState("");
  const [waybillNumber, setWaybillNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const Baseurl = process.env.REACT_APP_BASEURL;
  const token = JSON.parse(localStorage.getItem("eftd-admin-token") || "{}")
    ?.data?.data?.token;

  const config = {
    headers: {Authorization: `Bearer ${token}`},
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!dispatchProviderName || !waybillNumber) {
      toast.error("Please fill in all fields.");
      return;
    }

    try {
      setLoading(true);
      await axios.patch(
        `${Baseurl}/api/admin/orders/${orderId}/items/${itemId}/set-dispatch-info`,
        {
          dispatchProviderName,
          waybillNumber,
        },
        {
          ...config,
        }
      );

      toast.success("Dispatch info submitted successfully.");
      setSelectedDeliveries([]);
      onClose?.();
    } catch (error) {
      console.error(error);
      toast.error("Failed to submit dispatch info.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="!p-4 !border-b !border-b-[#dfe1e7]">
        <div className="flex items-center justify-between">
          <p className="!text-xl !font-semibold !text-[#36394a]">
            Assign Dispatch
          </p>
          <button onClick={onClose}>
            <XMarkIcon width={24} height={24} color="#666D80" />
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4 p-4">
        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700">
            Dispatch Provider Name
          </label>
          <input
            type="text"
            className="border border-gray-300 rounded px-3 py-2 text-sm"
            placeholder="e.g. DHL, GIG"
            value={dispatchProviderName}
            onChange={(e) => setDispatchProviderName(e.target.value)}
          />
        </div>

        <div className="flex flex-col">
          <label className="text-sm font-medium text-gray-700">
            Waybill Number
          </label>
          <input
            type="text"
            className="border border-gray-300 rounded px-3 py-2 text-sm"
            placeholder="Enter waybill number"
            value={waybillNumber}
            onChange={(e) => setWaybillNumber(e.target.value)}
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className={`w-full rounded bg-[#FE7F1F] text-white py-2 font-semibold text-sm ${
            loading ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          {loading ? "Submitting..." : "Submit Dispatch Info"}
        </button>
      </form>
    </>
  );
};

export default DispatchInfoForm;
